import React from 'react';
import ChatbotButton from './ChatbotButton';
import ChatbotPanel from './ChatbotPanel';
import './chatbot.scss';

interface ChatbotProps {
  onApplyFilters: (filters: any) => void;
  useSimplePrompts?: boolean;
}

const Chatbot: React.FC<ChatbotProps> = ({ onApplyFilters, useSimplePrompts = false }) => {
  const handleApplyFilters = (filters: any) => {
    if (!filters) return;

    // The filters are already in the correct format from filterMapper
    // Just pass them through to the parent component
    onApplyFilters(filters);
  };

  return (
    <div className="chatbot-container">
      <ChatbotPanel onApplyFilters={handleApplyFilters} useSimplePrompts={useSimplePrompts} />
      <ChatbotButton />
    </div>
  );
};

export default Chatbot;